import React, { useState } from "react";
import { Box, Drawer, useMediaQuery, CircularProgress, Typography } from "@mui/material";
import BookmarksTable from "../../components/Bookmarks/BookmarksTable";
import BookmarksSidebar from "../../components/Bookmarks/BookmarksSidebar";
import { useSelector } from "react-redux";

const Bookmarks = () => {
  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const [selectedGroup, setSelectedGroup] = useState({});
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isDeleteBookmarkLoading, setIsDeleteBookmarkLoading] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
       backgroundColor: "#F8FAFC",
        height: "calc(100vh - 50px)",
        width: "100%",
      }}
    >
      {isMobileView ? (
        <Drawer
          anchor="left"
          open={isSidebarOpen}
          ModalProps={{
            keepMounted: true,
          }}
          onClose={toggleSidebar}
        >
          <BookmarksSidebar
            toggleSidebar={toggleSidebar}
            selectedGroup={selectedGroup}
            setSelectedGroup={setSelectedGroup}
            isDeleteBookmarkLoading={isDeleteBookmarkLoading}
            setIsDeleteBookmarkLoading={setIsDeleteBookmarkLoading}
          />
        </Drawer>
      ) : (
        <BookmarksSidebar
          toggleSidebar={toggleSidebar}
          selectedGroup={selectedGroup}
          setSelectedGroup={setSelectedGroup}
          isDeleteBookmarkLoading={isDeleteBookmarkLoading}
          setIsDeleteBookmarkLoading={setIsDeleteBookmarkLoading}
        />
      )}

      <BookmarksTable
        toggleSidebar={toggleSidebar}
        selectedGroup={selectedGroup}
      />
      
      {/* Global Delete Loader Overlay - Visible on all screens */}
      {isDeleteBookmarkLoading && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              backgroundColor: 'white',
              padding: { xs: 2, sm: 3 },
              borderRadius: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
              width: { xs: '90%', sm: 'auto', md: 'auto' },
              maxWidth: { xs: '300px', sm: '400px', md: 'auto' },
            }}
          >
            <CircularProgress size={{ xs: 30, sm: 35, md: 40 }} sx={{ color: '#003D78' }} />
            <Typography 
              variant="h6" 
              sx={{ 
                color: '#003D78', 
                fontWeight: 600,
                fontSize: { xs: '16px', sm: '18px', md: '20px' },
                textAlign: 'center'
              }}
            >
              Deleting Group...
            </Typography>
            <Typography 
              variant="body2" 
              color="textSecondary"
              sx={{
                fontSize: { xs: '12px', sm: '14px', md: '16px' },
                textAlign: 'center'
              }}
            >
              Please wait while we delete your bookmark group.
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Bookmarks;
